module.exports = __webpack_public_path__ + "media/old_images/icon-pause@2x-81076f1b.png";